import { blake3 } from '@noble/hashes/blake3';
import { FILTER_TAG_DATA_LENGTH } from '../../constants/envelope';

export type FilterTag = Uint8Array; // Always 6 bytes

/**
 * Derives a 6-byte filter tag containing:
 * - Byte 0: bit length (1–40)
 * - Bytes 1–5: up to 40 bits of hashed tag data (left-aligned, zero-padded)
 */
export function deriveFilterTag({
  viewKey,
  index,
  bits,
}: {
  viewKey: Uint8Array;
  index: number;
  bits: number;
}): FilterTag {
  if (viewKey.length !== 32) throw new Error('View key must be 32 bytes');
  if (bits < 1 || bits > 40) throw new Error('bits must be between 1 and 40');

  // Encode index to 4 bytes (LE)
  const indexBytes = new Uint8Array(4);
  new DataView(indexBytes.buffer).setUint32(0, index, true);

  // Hash(viewKey || index)
  const hash = blake3(new Uint8Array([...viewKey, ...indexBytes]));

  // Take first 5 bytes (40 bits) of the hash
  let rawBits = 0n;
  for (let i = 0; i < FILTER_TAG_DATA_LENGTH; i++) {
    rawBits = (rawBits << 8n) | BigInt(hash[i]);
  }

  // Left-align the meaningful bits
  const shift = 40n - BigInt(bits);
  const tagBits = (rawBits >> shift) << shift;

  // Build the final tag
  const tag = new Uint8Array(1 + FILTER_TAG_DATA_LENGTH);
  tag[0] = bits; // Prefix with bit length
  for (let i = 0; i < FILTER_TAG_DATA_LENGTH; i++) {
    tag[i + 1] = Number((tagBits >> BigInt((FILTER_TAG_DATA_LENGTH - 1 - i) * 8)) & 0xffn);
  }

  return tag;
}